module.exports = __webpack_public_path__ + "media/src/images/buttons/hover_apple_pay-de9f98dd88f7d2889394fc0fd72c0a70.svg";